import type { GridRowId, GridRowSelectionModel } from '@mui/x-data-grid-pro';

export const createIncludeSelectionModel = (ids: Iterable<GridRowId>): GridRowSelectionModel => ({
  type: 'include',
  ids: new Set(ids),
});

export const getIncludedSelectionIds = (selection: GridRowSelectionModel): string[] =>
  selection.type === 'include' ? Array.from(selection.ids, String) : [];
